module.exports = __webpack_public_path__ + "static/media/porte3.37d7b111.jpg";